import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvOvulatoryEventEmptyStateProps {
  title: string;
  children: ReactNode;
  tone?: 'neutral' | 'error';
}

const OvOvulatoryEventEmptyState: FC<OvOvulatoryEventEmptyStateProps> = ({
  title,
  children,
  tone = 'neutral',
}) => (
  <Wrapper role={tone === 'error' ? 'alert' : 'status'}>
    <Title $error={tone === 'error'}>{title}</Title>
    <Body>{children}</Body>
  </Wrapper>
);

export default OvOvulatoryEventEmptyState;

const Wrapper = styled.div`
  padding: 0.75rem 0 1.5rem;
`;

const Title = styled.h3<{ $error: boolean }>`
  margin: 0 0 0.5rem;
  color: ${({ $error }) =>
    $error ? Colours.OV_ACCENT_MAGENTA : Colours.OV_BASE};
  font-size: ${Variables.fontSizes.LARGE};
  font-weight: bold;
`;

const Body = styled.div`
  max-width: 44rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.MEDIUM};
  line-height: ${Variables.lineHeights.MLARGE};

  p {
    margin: 0 0 0.5rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
